var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.57647 16 0 12.4235 0 8C0 3.57647 3.57647 0 8 0C12.4235 0 16 3.57647 16 8C16 12.4235 12.4235 16 8 16ZM8 0.941176C4.09412 0.941176 0.941176 4.09412 0.941176 8C0.941176 11.9059 4.09412 15.0588 8 15.0588C11.9059 15.0588 15.0588 11.9059 15.0588 8C15.0588 4.09412 11.9059 0.941176 8 0.941176Z",
    fill: "#ABA7AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9058 8.79982L7.99991 4.89393L4.09403 8.79982L3.4352 8.14099L7.99991 3.57629L12.5646 8.14099L11.9058 8.79982Z",
    fill: "#ABA7AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52941 4.23529H8.47059V12.2353H7.52941V4.23529Z",
    fill: "#ABA7AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDisable);
export default __webpack_public_path__ + "static/media/UpDisable.d78ce3a7ef3d782ad6654cc98d0c3058.svg";
export { ForwardRef as ReactComponent };